import * as actionTypes from "../actions/actionTypes";

const initialState = {};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_WORKING_HOURS:
      return action.workingHours;
    default:
      return state;
  }
};

export default reducer;
